/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiDocumentsDtoCompanyDocumentDto
 */
export interface WebApiDocumentsDtoCompanyDocumentDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiDocumentsDtoCompanyDocumentDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiDocumentsDtoCompanyDocumentDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiDocumentsDtoCompanyDocumentDto
     */
    folder?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiDocumentsDtoCompanyDocumentDto
     */
    sizeBytes?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiDocumentsDtoCompanyDocumentDto
     */
    contentType?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiDocumentsDtoCompanyDocumentDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof WebApiDocumentsDtoCompanyDocumentDto
     */
    createdBy?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiDocumentsDtoCompanyDocumentDto
     */
    createdByName?: string | null;
}

/**
 * Check if a given object implements the WebApiDocumentsDtoCompanyDocumentDto interface.
 */
export function instanceOfWebApiDocumentsDtoCompanyDocumentDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiDocumentsDtoCompanyDocumentDtoFromJSON(json: any): WebApiDocumentsDtoCompanyDocumentDto {
    return WebApiDocumentsDtoCompanyDocumentDtoFromJSONTyped(json, false);
}

export function WebApiDocumentsDtoCompanyDocumentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiDocumentsDtoCompanyDocumentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'folder': !exists(json, 'folder') ? undefined : json['folder'],
        'sizeBytes': !exists(json, 'sizeBytes') ? undefined : json['sizeBytes'],
        'contentType': !exists(json, 'contentType') ? undefined : json['contentType'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'createdByName': !exists(json, 'createdByName') ? undefined : json['createdByName'],
    };
}

export function WebApiDocumentsDtoCompanyDocumentDtoToJSON(value?: WebApiDocumentsDtoCompanyDocumentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'fileName': value.fileName,
        'folder': value.folder,
        'sizeBytes': value.sizeBytes,
        'contentType': value.contentType,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'createdBy': value.createdBy,
        'createdByName': value.createdByName,
    };
}

